import { defineMessages } from "react-intl"

const messages = defineMessages({
  tagThisItem: {
    id: "tag.tag-this-item",
    defaultMessage: "Tag this item"
  },
  enterTagNames: {
    id: "tag.enter-tag-names",
    defaultMessage: "Enter tag name/s"
  },
  add: {
    id: "tag.add",
    defaultMessage: "Add"
  },
  loginToAdd: {
    id: "tag.login-to-add",
    defaultMessage: "Login to add a tag to this item"
  },
  addMultiple: {
    id: "tag.add-multiple",
    defaultMessage:
      "Enter multiple tags by seperating with a comma, e.g. flying<strong>,</strong> car<strong>,</strong> child<strong>,</strong> Etc"
  },
  addTag: {
    id: "tag.add-tag-to-item",
    defaultMessage: "Add a tag to this item"
  }
})

export default messages



// WEBPACK FOOTER //
// ./webapp/messages/tags.js